export default "__VITE_PUBLIC_ASSET__0c041e58__"